//* import statements
import React, {
  useState,
  useEffect,
  useContext,
} from "react";
import { AuthContext } from "../../store/auth-context";
import Navigation from "./Navigation";
import MobileMenu from "../MobileMenu/MobileMenu";
import styles from "./Header.module.css";

const Header = () => {
  const authCtx = useContext(AuthContext);

  //*states
  const [showNavigation, setShowNavigation] =
    useState(false);
  //* functions
  const showNavigationHandler = (bool) => {
    setShowNavigation(bool);
  };

  useEffect(() => {
    if (!authCtx.isLoggedIn) {
      setShowNavigation(false);
    }
  }, [authCtx.isLoggedIn]);
  return (
    <div className={styles["header"]}>
      <h1 id={styles["header-logo"]}>
        A typical Page
      </h1>
      {authCtx.isLoggedIn && (
        <Navigation
          className={styles["header__navigation"]}
        />
      )}
      {authCtx.isLoggedIn && showNavigation && (
        <Navigation
          className={
            styles["mobile-menu__navigation"]
          }
        />
      )}

      {authCtx.isLoggedIn && (
        <MobileMenu
          onShowNavigation={showNavigationHandler}
        />
      )}
    </div>
  );
};

export default Header;
